import { ArrowDownIcon as o, ArrowUpIcon as s } from "../../icons/index.es.js";
const c = {
  asc: "asc",
  desc: "desc"
}, E = {
  [c.asc]: "A-Z",
  [c.desc]: "Z-A"
}, n = {
  [c.asc]: o,
  [c.desc]: s
};
export {
  c as SELECT_SORT,
  n as SELECT_SORT_ICON,
  E as SELECT_SORT_LABEL
};
//# sourceMappingURL=Select.constants.es.js.map
